/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Hours_LabelInputs */



/**
* | output |
* | --- |
* | "Hours" |
*
* @param {Subtitle_Export_Hours_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_hours_label = /** @type {((inputs?: Subtitle_Export_Hours_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Hours_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Heures")
	if (locale === "de") return /** @type {LocalizedString} */ ("Std")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Часы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Horas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("小时")
	if (locale === "ja") return /** @type {LocalizedString} */ ("営業時間")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घंटे")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Horas")
	return /** @type {LocalizedString} */ ("Hours")
});